import { Link } from 'react-router-dom'
import { Clock, Lock } from 'lucide-react'

// P0.53 (29/08/2026, Sección 6 del encargo): ELITE retirado -- nunca es un plan real
// asignable a un cliente (`plan_tiers.py` nunca lo mapea).
const PLAN_LABEL: Record<string, string> = { PRO: 'Pro', BLACK: 'Black' }

/** Se muestra cuando el backend responde `locked: true` (plan insuficiente) -- nunca un error
 * ni una lista vacía sin explicación. El backend nunca oculta sin decir por qué (mismo
 * principio que `exists: false` en /picks).
 *
 * P0.51.1 (29/08/2026, Sección I/K del encargo): `trialExpired` cambia el copy a algo
 * específico de "tu prueba terminó" (nunca "disponible en plan PRO" como si el FREE nunca
 * hubiera tenido esto -- durante el trial SÍ lo tuvo). Mismo componente, mismo CTA -- no se
 * promete nada que no exista hoy (nunca "IA avanzada"/"Bankroll Intelligence", ver
 * BLACK_PRODUCT_GAP). */
export function UpgradePrompt({
  requiredPlan,
  feature,
  trialExpired,
}: {
  requiredPlan: string
  feature: string
  trialExpired?: boolean
}) {
  return (
    <div className="card text-center py-8 space-y-3 animate-fade-in-up motion-reduce:animate-none">
      <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-panel-elevated mx-auto">
        {trialExpired ? (
          <Clock className="h-5 w-5 text-text-dim" />
        ) : (
          <Lock className="h-5 w-5 text-text-dim" />
        )}
      </span>
      <div>
        <p className="text-sm font-semibold">
          {trialExpired
            ? 'Tu prueba gratuita de 7 días ha terminado'
            : `${feature} disponible en plan ${PLAN_LABEL[requiredPlan] ?? requiredPlan}`}
        </p>
        <p className="text-xs text-text-muted mt-1 max-w-[28ch] mx-auto leading-relaxed">
          {trialExpired
            ? 'Pasa a PRO o BLACK para recuperar el acceso completo.'
            : 'Actualiza tu plan para desbloquear esta sección.'}
        </p>
      </div>
      <Link
        to="/mas/suscripcion"
        className="inline-block px-4 py-2 rounded-lg bg-brand text-black text-sm font-semibold"
      >
        Ver planes
      </Link>
    </div>
  )
}
